interface ButtonToggleProps {
  vehicleToggle: boolean;
  setVehicleToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ButtonToggle({
  vehicleToggle,
  setVehicleToggle,
}: ButtonToggleProps) {
  const handleChange = () => {
    setVehicleToggle(!vehicleToggle);
  };
  return (
    <label htmlFor="toggleB" className="flex items-center cursor-pointer">
      <div className="relative">
        <input
          type="checkbox"
          id="toggleB"
          className="sr-only"
          checked={vehicleToggle}
          onChange={handleChange}
        />

        <div className="block h-6 bg-[#E6E6E6] rounded-full w-11 dot0"></div>

        <div className="absolute w-4 h-4 transition bg-white rounded-full dot left-1 top-1"></div>
      </div>
    </label>
  );
}
